import axios from "axios";

// Create an instance of axios with base configuration
const apiService = axios.create({
  baseURL: "https://api.icarda.ajatus.in/api", // Base URL for your API
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor to include the token in headers
apiService.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`; // Assuming Bearer token
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default apiService;
